import { ApolloLink, fromPromise } from '@apollo/client';
import { getAuthCheck } from '@lingoda/auth';

interface Params {
    onUnauthorized: () => void;
}

export const getAuthRestLink = (params: Params) =>
    new ApolloLink((operation, forward) => {
        // An operation without error handling gets the failed request instead of a logout
        const onUnauthorized = operation.getContext().noErrorHandling
            ? undefined
            : params.onUnauthorized;

        return fromPromise(getAuthCheck('', onUnauthorized)).flatMap(() => {
            return forward(operation);
        });
    });
